export const requestsApi = (client) => ({
    list: (params) => client.get('/api/v1/requests', { params }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/requests/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/requests', body).then((r) => r.data),
    // Nullable, not `undefined`-only — clearing a previously-set field on
    // edit requires explicitly sending `null` (omitting a key means
    // "leave unchanged" under the backend's sparse-update semantics).
    update: (id, body) => client.patch(`/api/v1/requests/${id}`, body).then((r) => r.data),
    /** Approve a request. By default the server auto-spawns a work
     *  order from the request's fields and emails the requester with
     *  the WO code. Pass `{ create_work_order: false }` to keep the
     *  status flip only — used when the UI wants to open the manual
     *  "New Work Order" dialog pre-filled from the request instead. */
    approve: (id, body) => client.post(`/api/v1/requests/${id}/approve`, body ?? {})
        .then((r) => r.data),
    decline: (id, reason) => client.post(`/api/v1/requests/${id}/decline`, { reason }).then((r) => r.data),
    linkWorkOrder: (id, work_order_id) => client.post(`/api/v1/requests/${id}/link-work-order`, { work_order_id }).then((r) => r.data),
});
//# sourceMappingURL=requests.js.map